























































































import Vue from "vue";
import Component from "vue-class-component";
import apiClient from "@/utilities/ApiClient";
import utils from "@/utilities/Utils";
import ApiButton from "@/vue/components/ApiButton.vue";
import { Contract } from "@/model/Contract";
import { ContractLine } from "@/model/ContractLine";
import { ContractLineGroupVM, IContractLineGroupVM } from "@/model/Api/VM/ContractLineGroupVM";
import { Retailer } from "@/model/Retailer";
import { SizeOptionGroup } from "@/model/SizeOptionGroup";
import { SizeOption } from "@/model/SizeOption";
import { SupplierVM, ISupplierVM } from "@/model/Api/VM/SupplierVM";
import { Ref, Watch } from "vue-property-decorator";
import { VForm } from "@/vForm";
import * as toastr from "toastr";

@Component({ components: { ApiButton } })

export default class ContractDialogue extends Vue {

    //
    // -- properties
    //

    @Ref("contractForm") private readonly contractForm!: VForm;  

    private showDialogue: boolean = false;
    private dialogueTitle: string = "";
    private isLoading: boolean = false;
    private isEdit: boolean = false;
    private contract: Contract = new Contract();
    private retailers: Array<Retailer> = [];
    private suppliers: Array<SupplierVM> = [];
    private sizeGroups: Array<SizeOptionGroup> = [];
    private sizeOptions: Array<SizeOption> = [];
    private contractLineGroups: Array<ContractLineGroupVM> = [];

    //
    // -- Watchers
    //

    @Watch("contract.sizeOptionGroupID")
    private async onSizeOptionGroupIDChanged() {
        if (this.isLoading) return;

        if (this.contractLineGroups.length == 0 && 
            this.contract.sizeOptionGroupID != "00000000-0000-0000-0000-000000000000" && 
            this.contract.sizeOptionGroupID != '') {

            await this.loadSizeOptions();
            
            var newLineGroup = new ContractLineGroupVM();

            this.sizeOptions.forEach(o => {
                var newLine = new ContractLine();
                newLine.size = o.contractSize;
                newLineGroup.lines.push(newLine);
            });

            this.contractLineGroups.push(newLineGroup);
        } else if (this.contract.sizeOptionGroupID != "00000000-0000-0000-0000-000000000000" && this.contract.sizeOptionGroupID != '') {
            await this.loadSizeOptions();
        } else {
            this.sizeOptions = [];
        }
    }

    //
    // -- methods
    //

    async add(): Promise<void> {
        this.reset();
        this.dialogueTitle = "Create New Contract";
        
        this.isLoading = true;
        await this.loadSizeOptionGroups();
        await this.loadRetailers();
        await this.loadSuppliers();
        this.isLoading = false;

        if (this.sizeGroups.length == 1) this.contract.sizeOptionGroupID = this.sizeGroups[0].id;

        this.isEdit = false;
        this.showDialogue = true;
    }

    async edit(contractID: string): Promise<void> {
        this.reset();
        this.dialogueTitle = "Edit Contract";
        
        this.isLoading = true;
        await this.loadSizeOptionGroups();
        await this.loadRetailers();
        await this.loadSuppliers();
        await this.loadContractForEdit(contractID);
        this.isLoading = false;

        this.isEdit = true;
        this.showDialogue = true;
    }

    addNewLineGroup(): void {
        //this.contractLineGroups.push(new ContractLineGroupVM());
        var newLineGroup = new ContractLineGroupVM();

        if (this.sizeOptions.length > 0) {
            this.sizeOptions.forEach(o => {
                var newLine = new ContractLine();
                newLine.size = o.contractSize;
                newLineGroup.lines.push(newLine);
            });
            this.contractLineGroups.push(newLineGroup);
        } else {
            newLineGroup.lines.push(new ContractLine());
            this.contractLineGroups.push(newLineGroup);
        }
        
    }

    addNewLine(group: ContractLineGroupVM): void {
        group.lines.push(new ContractLine());
    }

    removeLine(group: ContractLineGroupVM, line: ContractLine): void {
        var index = -1;

        for (var i = 0; i < group.lines.length; i++) {
            if (group.lines[i] == line) {
                index = i;
                break;
            }
        }

        group.lines.splice(index, 1);

        if (group.lines.length == 0) {
            var groupIndex = -1;

            for (var gi = 0; gi < this.contractLineGroups.length; gi++) {
                if (this.contractLineGroups[gi] == group) {
                    groupIndex = gi;
                    break;
                }
            }

            this.contractLineGroups.splice(groupIndex, 1);
        }
    }

    private async save() {
        if (!this.contractForm.validate()) {
            toastr.warning("Please fix highlighted issues", "Cannot Save");
            return;
        }

        var postData = {
            contract: this.contract,
            lineGroups: this.contractLineGroups
        }

        var apiPoint = this.isEdit ? "/api/contract/saveContract" : "/api/contract/createContract";
        const response = await apiClient.post(apiPoint, postData, "save-order");
        if (response.isSuccess) {
            toastr.success("Saved"); 
            this.$emit("refreshSearch");
            this.$emit("openPreview", this.isEdit ? this.contract.id : response.newID);
            this.showDialogue = false;
        } else {
            toastr.warning("Failed to Save"); 
        }
    }


    private reset() {
        utils.resetObject(this.contract);
        this.retailers = [];
        this.suppliers = [];
        this.contractLineGroups = [];
        this.contractForm?.resetValidation();
    }

    private async loadContractForEdit(contractID: string) {
        const response = await apiClient.get(`/api/contract/contractForEdit?id=${contractID}`);
        this.contractLineGroups.push(...response.lineGroups.map((g: IContractLineGroupVM) => new ContractLineGroupVM(g)));
        this.contract.update(response.contract.contract);
    }

    private async loadSizeOptionGroups() {
        this.sizeGroups = [];
        const response = await apiClient.get("/api/size/loadCustomContractGroups");
        this.sizeGroups.push(...response);
    }

    private async loadRetailers() {
        this.retailers = [];
        const response = await apiClient.get("/api/product/retailers");
        this.retailers.push(...response);

        if (this.retailers.length == 1) this.contract.retailerID = this.retailers[0].id;
    }

    private async loadSuppliers() {
        this.suppliers = [];
        const response = await apiClient.get("/api/supplier/userSuppliersDetailed");
        this.suppliers.push(...response.map((s: ISupplierVM) => new SupplierVM(s)));

        if (this.suppliers.length == 1) this.contract.supplierID = this.suppliers[0].supplier.id;
    }

    private async loadSizeOptions() {
        this.sizeOptions = [];
        const response = await apiClient.get(`/api/size/loadSizeGroupSizeOptions?groupID=${this.contract.sizeOptionGroupID}`);
        this.sizeOptions.push(...response);
    }
}
